// GENERATED by tools/generate-visible-text-tables.py from tools/visible-text/blank-set-15.0.0.json
// (sha256 d90d7d9384923a5c30077d677c8e124e46f5be2ecb09ee5a6c286fab62b4efd6). DO NOT EDIT: change the canonical file and regenerate.
// D-378 / SPEC-SERVICE-INTEGRATION RULE-INTEG-031 (a); Unicode 15.0.0.

/** The Unicode version the blank table is pinned to. */
export const VISIBLE_TEXT_UNICODE_VERSION = "15.0.0";

/** sha256 of the canonical file this table was generated from. */
export const VISIBLE_TEXT_CANONICAL_SHA256 = "d90d7d9384923a5c30077d677c8e124e46f5be2ecb09ee5a6c286fab62b4efd6";

/** Inclusive [start, end] code point ranges, sorted and non-overlapping. */
export const BLANK_RANGES: ReadonlyArray<readonly [number, number]> = [
  [0x0000, 0x0020],
  [0x007F, 0x00A0],
  [0x00AD, 0x00AD],
  [0x034F, 0x034F],
  [0x061C, 0x061C],
  [0x115F, 0x1160],
  [0x1680, 0x1680],
  [0x17B4, 0x17B5],
  [0x180B, 0x180F],
  [0x2000, 0x200F],
  [0x2028, 0x202F],
  [0x205F, 0x206F],
  [0x2800, 0x2800],
  [0x3000, 0x3000],
  [0x3164, 0x3164],
  [0xFE00, 0xFE0F],
  [0xFEFF, 0xFEFF],
  [0xFFA0, 0xFFA0],
  [0xFFF0, 0xFFF8],
  [0x1BCA0, 0x1BCA3],
  [0x1D159, 0x1D159],
  [0x1D173, 0x1D17A],
  [0xE0000, 0xE0FFF],
];
